/** @format */

import usePrice from '@/@ducks/cardRoom/hooks/usePrice';
import ArrowDown from '@/assets/icons/card-room-arrow-down-icon.svg';
import { Icon } from '@/components/ui/Icon';
import React from 'react';
import {
  BasePrice,
  DiscountPercentage,
  FormattedPrice,
  Month,
  NumbersWrapper,
  PromoBasePercetagePrice,
  PromoDateWrapper,
  Wrapper,
} from './Price.style';
import { useCardRoomContext } from './context';
import { PriceTooltip } from './PriceTooltip';

type PriceProps = {
  hideDateDetails?: boolean;
  isPopup?: boolean;
};

const Price: React.FC<PriceProps> = ({ hideDateDetails, isPopup }) => {
  const { room } = useCardRoomContext();
  const {
    roomHasPromo,
    basePrice,
    getFormattedDiscountUntilDate,
    formattedPrice,
    monthPriceText,
    formattedDiscountedPricePercentage,
  } = usePrice(room!);

  const showPromoPrice = roomHasPromo && room?.basePrice !== room?.discountedPrice;

  return (
    <Wrapper isPopup={isPopup}>
      <NumbersWrapper>
        <FormattedPrice>
          <span>{formattedPrice}</span>
          <Month>{monthPriceText}</Month>
        </FormattedPrice>
        {showPromoPrice && (
          <PromoBasePercetagePrice>
            <BasePrice>{basePrice}</BasePrice>
            <DiscountPercentage>
              <Icon icon={ArrowDown} color="#D92D20" width={18} height={18} />
              <span>{formattedDiscountedPricePercentage}</span>
            </DiscountPercentage>
          </PromoBasePercetagePrice>
        )}
      </NumbersWrapper>
      {showPromoPrice &&
        !hideDateDetails &&
        (isPopup ? (
          <PriceTooltip formattedDiscountUntilDate={getFormattedDiscountUntilDate(isPopup)} />
        ) : (
          <PromoDateWrapper>{getFormattedDiscountUntilDate(!!isPopup)}</PromoDateWrapper>
        ))}
    </Wrapper>
  );
};

export default Price;
